module.exports = __webpack_public_path__ + "img/3.d91a36d1.jpg";